<template>
  <div class="dashboard">
    <h1>Dashboard Comparativo</h1>
    <canvas id="myChart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';
import axios from 'axios';

export default {
  name: 'DashboardPage',
  data() {
    return {
      chart: null,
    };
  },
  async mounted() {
    try {
      const response = await axios.get('/api/dashboard');
      const data = response.data;

      const labels = data.map((item) => item.dia);
      const atencionesData = data.map((item) => item.atenciones);
      const pagosData = data.map((item) => item.pagos);

      const ctx = document.getElementById('myChart').getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Atenciones',
              data: atencionesData,
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
            {
              label: 'Pagos',
              data: pagosData,
              backgroundColor: 'rgba(153, 102, 255, 0.6)',
              borderColor: 'rgba(153, 102, 255, 1)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>

<style scoped>
.dashboard {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
